export const PAGE_SIZE = 40;
export const NATIONAL_CALENDAR_NAME = 'National';
export const DEFAULT_SORT_ORDER = ['name,asc'];
export const DEFAULT_ACTIVE = true;
